import { ITypedReduxAction } from '../../../types/redux/actionType';
import { ICurrentRegion } from '../../../types/geo';

export enum ESetCurrentRegionActionType {
  Set = 'geo/currentRegion/set',
}

export type TSetCurrentRegion = ITypedReduxAction<ESetCurrentRegionActionType.Set, ICurrentRegion>;
